import {combineReducers, Reducer} from 'redux'
import {reducer as formReducer} from 'redux-form'
import {createTransform} from 'redux-persist'

import loginReducer, {model as loginModel, persist as loginPersist} from './login'
import {IState as MainState, reducer as mainReducer} from './main'
import persistReducer, {
  model as persistModel,
} from './persist'
import {
  IState as IStudyCoordinatorState,
  reducer as studyCoordinatorReducer,
} from './study-coordinator'
import subjectsReducer, {model as subjectsModel} from './subjects'

import clearStateEnhance from 'core/store/enhancers/clearStateEnhance'

export interface IState {
  main: MainState
  login: loginModel.IState
  subjects: subjectsModel.IState
  persist: persistModel.IState
  studyCoordinator: IStudyCoordinatorState
}

const reducer: Reducer<IState> = combineReducers<IState>({
  login: clearStateEnhance(loginReducer),
  subjects: clearStateEnhance(subjectsReducer),
  form: clearStateEnhance(formReducer),
  studyCoordinator: clearStateEnhance(studyCoordinatorReducer),
  main: mainReducer,
  persist: persistReducer,
})
export default reducer

export const persistReducerKeys = ['login']

export const transforms = [
  createTransform<loginModel.IState, loginPersist.IPersistState>(
    (inboundState) => loginPersist.persistState(inboundState),
    (outboundState) => loginPersist.hydrateState(outboundState),
    { whitelist: ['login'] },
  ),
]



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/reducer.ts